import React from 'react';
import styled from 'styled-components';
import { Loader } from '../atoms/Loader';
import { Stylesheet } from '../atoms/Stylesheet';

const StyledDiv = styled.div`
  height: ${(props: { height?: number }) =>
    props.height ? `${props.height}px` : undefined};
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface Props {
  children: any;
  href: string;
  loaderHeight?: number;
  style?: React.CSSProperties;
}

export const StylesheetLoader = (props: Props) => {
  const [cssLoaded, setCssLoaded] = React.useState(false);
  const onLoad = () => {
    setCssLoaded(true);
  };
  const { children, href, loaderHeight, style } = props;

  return (
    <div style={style}>
      <Stylesheet href={href} onLoad={onLoad} />
      {cssLoaded ? (
        <StyledDiv height={loaderHeight}>{children}</StyledDiv>
      ) : (
        // children
        <StyledDiv height={loaderHeight}>
          <Loader />
        </StyledDiv>
      )}
    </div>
  );
};
